const algoliasearch = require('algoliasearch/lite')
const instantsearch = require('instantsearch.js').default

import {
  searchBox,
  menu,
  infiniteHits,
  configure,
  analytics,
} from 'instantsearch.js/es/widgets'

export default class AlgoliaSearch {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.searchBox = this.el.querySelector('[search-input]')
    // Note, this must match what's in the config/.env file
    this.appId = window.agI
    this.apiKey = window.agSk
    this.index = window.agSi
    this.env = window.Environment
    this.limit = 8
  }

  // Algolia JS API Settings
  init() {
    if (!this.checkRequirements()) {
      console.log('search requirements not met. Preventing load')
      return false
    }

    const includeAnalytics = this.env === 'production'
    const searchClient = algoliasearch(this.appId, this.apiKey)
    const moduleEl = this.el
    const search = instantsearch({
      indexName: this.index,
      analytics: includeAnalytics,
      searchFunction(helper) {
        const container = document.querySelector('#hits')
        const hitswrapper = document.querySelector('#hits-wrapper')
        const refineContainer = document.querySelector(
          '#refinementList',
        )
        if (helper.state.query === '') {
          container.style.display = 'none'
          hitswrapper.style.display = 'none'
          refineContainer.style.display = 'none'
          moduleEl.classList.remove('s-results-showing')
        } else {
          container.style.display = ''
          hitswrapper.style.display = ''
          refineContainer.style.display = ''
          moduleEl.classList.add('s-results-showing')
        }

        helper.search()
      },
      searchClient,
    })

    search.addWidgets([
      configure({
        hitsPerPage: this.limit,
        distinct: true,
        facetingAfterDistinct: true,
      }),
    ])

    search.addWidgets([
      searchBox({
        container: '#searchbox',
        placeholder: 'search...',
        showReset: false,
        showSubmit: true,
        cssClasses: {
          root: ['form__algolia-search'],
          input: ['form__algolia-search-input'],
          form: ['form__algolia-search-form'],
          submit: ['form__algolia-search-submit'],
          reset: ['form__algolia-search-reset'],
        },
      }),

      menu({
        container: '#refinementList',
        attribute: 'type',
        sortBy: ['name:desc'],
      }),
      infiniteHits({
        container: '#hits',
        escapeHTML: true,
        templates: {
          item: `
                        <article class="search__results__item"
                         data-insights-object-id="{{objectID}}"
 data-insights-position="{{__position}}"
 data-insights-query-id="{{__queryID}}">
                            <a href="{{url}}">
                                <img src="{{image}}" alt="">
                                <div class="flex items-center flex-wrap gap-3">
                                    <h3 class="search__results__heading">{{#helpers.highlight}}{ "attribute": "title", "highlightedTagName": "mark" }{{/helpers.highlight}}</h3>
                                    {{#protected }}
                                    <div class="flex gap-1 items-center">
                                        <svg class="fill-current w-3 h-3 opacity-50" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M144 144v48H304V144c0-44.2-35.8-80-80-80s-80 35.8-80 80zM80 192V144C80 64.5 144.5 0 224 0s144 64.5 144 144v48h16c35.3 0 64 28.7 64 64V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V256c0-35.3 28.7-64 64-64H80z"/></svg>
                                       <span class="text-xs">Requires Customer Care Account</span>
                                    </div>
                                    {{/protected }}
                                </div>

                                <p class="search__results__summary">{{ copy }}{{#helpers.snippet}}{"attribute": "copy"}{{/helpers.snippet}}</p>

                                <div class="search__results__meta">
                                    {{#sku}}<div class="search__results__meta--sku">SKU: {{ sku }}</div>{{/sku}}
                                </div>

                            </a>
                        </article>`,
        },
      }),
    ])
    search.addWidgets([
      analytics({
        pushFunction(formattedParameters, state, results) {
          dataLayer.push({
            // prettier-ignore
            event: 'search',
            'Search Query': state.query,
            'Facet Parameters': formattedParameters,
            'Number of Hits': results.nbHits,
          })
        },
        delay: 3000,
      }),
    ])
    search.start()
  }

  checkRequirements() {
    // Check if #searchbox is there
    if (!this.el.querySelector('#searchbox')) {
      console.log('missing search box selector')
      return false
    }
    if (!this.el.querySelector('#refinementList')) {
      console.log('missing refinement list elector')
      return false
    }
    if (!this.el.querySelector('#hits')) {
      console.log('missing hits selector')
      return false
    }
    return true
  }
}
